import { motion } from "framer-motion";
import {
    ArrowRight,
    ChevronLeft,
    ChevronRight
} from "lucide-react";
import { useRef } from "react";
import NoImage from "../../assets/NoImage.png";

export default function CommunityProducts({

    community,

    products = [],

    onProductClick,

    onShopCollection,

    onWishlist

}) {

    const scrollRef = useRef(null);
    console.log("Products received:", products);

    const normalizeProducts = (input) => {
        if (Array.isArray(input)) return input;
        if (!input || typeof input !== "object") return [];

        if (Array.isArray(input.products)) return input.products;
        if (Array.isArray(input.data)) return input.data;
        if (Array.isArray(input.items)) return input.items;
        if (Array.isArray(input.result)) return input.result;
        if (Array.isArray(input.results)) return input.results;

        return Object.values(input).filter(
            (value) => value && typeof value === "object" && !Array.isArray(value)
        );
    };

    const normalizedProducts = normalizeProducts(products);
console.log("Normalized:", normalizedProducts);
    
    const scroll = (direction) => {
        if (!scrollRef.current) return;

        const amount = 320;

        scrollRef.current.scrollBy({
            left: direction === "left" ? -amount : amount,
            behavior: "smooth",
        });
    };

    return (

        <section className="mt-24">

            {/* Header */}

            <div className="bg-white rounded-[32px] shadow-sm border border-gray-100 p-8">

                <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6">

                    <div>

                        <h2 className="text-3xl font-bold text-gray-900">
                            Dream Collection
                        </h2>

                        <p className="mt-2 text-gray-500">
                            Wear the mindset of imagination and endless possibilities.
                        </p>

                    </div>

                    <button
                        onClick={onShopCollection}
                        className={`
                inline-flex
                items-center
                gap-2
                px-7
                py-3
                rounded-full
                text-white
                font-semibold
                shadow-lg
                transition
                ${community.button}
            `}
                    >
                        Shop {community.shortTitle}
                        <ArrowRight size={18} />
                    </button>

                </div>
            </div>

            {/* Products */}

            <div className="relative mt-10">

                <button
                    onClick={() => scroll("left")}
                    className="
            hidden
            lg:flex
            absolute
            left-0
            top-1/2
            -translate-y-1/2
            z-20
            w-10
            h-10
            rounded-full
            bg-white
            shadow-lg
            items-center
            justify-center
        "
                >
                    <ChevronLeft size={18} />
                </button>

                <div
                    ref={scrollRef}
                    className="
            flex
            gap-6
            overflow-x-auto
            snap-x
            scroll-smooth
            scrollbar-hide
            px-2
        "
                >

                    {normalizedProducts.length === 0 ? (
                        <div className="w-full rounded-3xl border border-dashed border-gray-200 bg-gray-50 px-6 py-10 text-center text-gray-500">
                            No products available for this community yet.
                        </div>
                    ) : (
                        normalizedProducts.map((product, index) => (

                            <motion.div

                                key={product.id}

                                initial={{
                                    opacity: 0,
                                    y: 30
                                }}

                                whileInView={{
                                    opacity: 1,
                                    y: 0
                                }}

                                viewport={{
                                    once: true
                                }}

                                transition={{
                                    delay: index * .08
                                }}

                                whileHover={{
                                    y: -8
                                }}

                                className="
    min-w-[210px]
    max-w-[210px]
    snap-start
"

                            >

                                {/* IMAGE */}

                                <div
                                    onClick={() => onProductClick(product)}
                                    className="
        bg-white
        rounded-3xl
        border
        border-gray-100
        overflow-hidden
        shadow-sm
        hover:shadow-xl
        transition-all
        duration-300
        cursor-pointer
"
                                >

                                    <img
                                        src={
                                            product.image ||
                                            NoImage
                                        }
                                        alt={product.name}
                                        className="
        w-full
        h-52
        object-contain
        p-4
    "
                                    />
                                </div>

                                {/* DETAILS */}

                                <div className="p-4">

                                    <h3
                                        className="
    text-base
    font-semibold
    text-gray-900
    line-clamp-2
"
                                    >

                                        {product.name}
                                        <p className="mt-1 text-sm text-gray-500">
                                            {product.color}
                                            {product.size && ` • ${product.size}`}
                                        </p>

                                    </h3>

                                    {product.variantLabel && (
                                        <p className="mt-1 text-sm text-gray-500">
                                            {product.variantLabel}
                                        </p>
                                    )}

                                    <div
                                        className="
                                    mt-2
                                    flex
                                    items-center
                                    gap-2
                                "
                                    >

                                        <span
                                            className="
    mt-1
    text-lg
    font-bold
    text-gray-900
"
                                        >

                                            ₹{product.price}

                                        </span>

                                        {

                                            product.oldPrice &&

                                            <span
                                                className="
                                            text-gray-400
                                            line-through
                                        "
                                            >

                                                ₹{product.oldPrice}

                                            </span>

                                        }

                                    </div>

                                    {/* Buttons */}



                                </div>

                            </motion.div>

                        ))
                    )}

                </div>

                <button
                    onClick={() => scroll("right")}
                    className="
        hidden
        lg:flex
        absolute
        right-0
        top-1/2
        -translate-y-1/2
        z-20
        w-10
        h-10
        rounded-full
        bg-white
        shadow-lg
        items-center
        justify-center
    "
                >
                    <ChevronRight size={18} />
                </button>
            </div>

        </section>

    );

}